import { defineStore } from "pinia";
import Services from '@/services/sutting/bodyMainPartsServices'
import { mapList, mapBodyMainParts } from '@/helpers/mapFuncs'


export const useBodyMainPartsStore = defineStore("bodyMainParts", {
persist: true,
state:()=>({
    bodyMainPart: {},
    bodyMainParts: [],
}),
getters : {
    getBodyMainPart() {
        return mapBodyMainParts(this.bodyMainPart)
    },
    getBodyMainParts() {
        return this.bodyMainParts.map(mapBodyMainParts)
    },
    getBodyMainPartsList() {
        return this.bodyMainParts.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setBodyMainPart(bodyMainPart) {
        this.college = bodyMainPart
    },
    setBodyMainParts(bodyMainParts) {
        this.bodyMainParts = bodyMainParts
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setBodyMainPart(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setBodyMainParts(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.bodyMainParts.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.bodyMainParts[this.bodyMainParts.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.bodyMainParts = this.bodyMainParts.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
